<script>
import model from "@/mixins/model";

export default {
  name: "TaskRecommendationsForm",

  mixins: [model],

  props: {
    isUpdate: { type: Boolean, default: false },
  },
};
</script>

<template lang="pug">
div
  .modal__row
    fieldset.modal__field
      label.label * Categoría:
      ValidationProvider(name="Categoría" rules="required" v-slot="{errors}")
        el-select(
          v-model="model.category"
          placeholder="Seleccioná una"
          required
        )
          el-option(label="Categoría 1" value="category1")
          el-option(label="Categoría 2" value="category2")
          el-option(label="Categoría 3" value="category3")
          el-option(label="Categoría 4" value="category4")

        span.has-error {{ errors[0] }}
  .modal__row
    fieldset.modal__field
      el-checkbox(v-model="model.isFeatured" :disabled="isUpdate")
        b Mostrar tarea como destacada
</template>
